<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />
    <div  v-if="!this.$store.getters.isLoading" class="flex xs12">
      <va-card :title="$t('events.locations')" style="overflow-x: auto;">
        <template slot="actions">
          <va-button to="new-location" icon="fa fa-plus"/>
        </template>
        <div class="va-card__body" v-if="locations.length < 1 || locationInfoMessage !== null">
          <va-notification v-if="locations.length < 1" color="info">
            <va-badge color="info">
              {{ $t('badges.info') }}
            </va-badge>
            {{ $t('events.noLocationsFound') }}
          </va-notification>
          <va-notification v-if="locationInfoMessage !== null" color="info">
            <va-badge color="info">
              {{ $t('badges.info') }}
            </va-badge>
            {{locationInfoMessage}}
          </va-notification>
        </div>
        <div>
          <div class="row">
            <div class="flex xs12">
              <va-tabs grow v-model="tabValue" @input="tabInput">
                <va-tab
                  v-for="title in tabTitles"
                  :key="title"
                >
                  {{title}}
                </va-tab>
              </va-tabs>
            </div>
          </div>
        </div>
      </va-card>
    </div>
    <div v-if="!this.$store.getters.isLoading && locations.length > 0" class="flex xs12">
      <div class="cards-container row d-flex wrap align--start location-cards">
        <div class="flex xs12 sm6 lg4 xl3" v-for="(location, index) in locations" v-bind:key="location.eventId">
          <va-card
            :image="getImagePath(location.image, index)"
          >
            <div class="va-card__header">
              <div class="va-card__header-title" @click="toLocation(location.eventId)" style="color: rgb(108, 127, 238);">{{ location.name }}</div>
              <div class="va-card__header-actions">
                <KebabMenu>
                  <div slot="buttons">
                    <va-button-group>
                      <va-button flat small color="gray" title="Open Location" @click="toLocation(location.eventId)" icon-right="fa fa-list"></va-button>
                      <va-button flat small color="gray" title="Archive" :disabled="removeDisabled" v-if="tabValue === 0" @click="showPromptModal(location.eventId, index, 'archive')" icon-right="fa fa-inbox"></va-button>
                      <va-button flat small color="gray" title="Duplicate" :disabled="removeDisabled" v-if="tabValue === 1" @click="showPromptModal(location.eventId, index, 'duplicate')" icon-right="fa fa-copy"></va-button>
                      <va-button flat small color="gray" title="Delete" :disabled="removeDisabled" @click="showPromptModal(location.eventId, index, 'remove')" icon-right="fa fa-trash"></va-button>
                    </va-button-group>
                  </div>
                </KebabMenu>
              </div>
            </div>
            <!--            {{ location.address }}-->
            <!--            <p v-if="!location.address"> No address for this location</p>-->
            <p>{{ $t('events.spots') }}: <span>{{ location.spotCount }} <va-icon name="fa fa-car"></va-icon></span></p>
            <p>{{ $t('events.employees') }}: <span>{{ location.userCount }} <va-icon name="fa fa-user"></va-icon></span></p>
            <p>{{ $t('events.clients') }}: <span>{{ location.clientCount }} <va-icon name="fa fa-users"></va-icon></span></p>
          </va-card>
        </div>
        <va-modal
          v-model="showArchiveModal"
          size="small"
          :title="$t('events.archiveModalTitle')"
          :message="$t('events.archiveModalMessage')"
          :hideDefaultActions="true"
          :noOutsideDismiss="true"
          :noEscDismiss="true"
        >
          <div class="d-flex justify--center mt-3">
            <va-button color="gray" @click="showArchiveModal=false" class="my-0 ">{{ $t('events.modalNo') }}</va-button>
            <va-button type="submit" @click="archiveLocation(locationIdInPrompt, indexInPrompt)" class="my-0">{{ $t('events.modalYes') }}</va-button>
          </div>
        </va-modal>
        <va-modal
          v-model="showDuplicateModal"
          size="small"
          :title="$t('events.duplicateModalTitle')"
          :message="$t('events.duplicateModalMessage')"
          :hideDefaultActions="true"
          :noOutsideDismiss="true"
          :noEscDismiss="true"
        >
          <div class="d-flex justify--center mt-3">
            <va-button color="gray" @click="showDuplicateModal=false" class="my-0 ">{{ $t('events.modalNo') }}</va-button>
            <va-button type="submit" @click="duplicateLocation(locationIdInPrompt, indexInPrompt)" class="my-0">{{ $t('events.modalYes') }}</va-button>
          </div>
        </va-modal>
        <va-modal
          v-model="showRemoveModal"
          size="small"
          :title="$t('events.deleteModalTitle')"
          :message="$t('events.deleteModalMessage')"
          :hideDefaultActions="true"
          :noOutsideDismiss="true"
          :noEscDismiss="true"
        >
          <div class="d-flex justify--center mt-3">
            <va-button color="gray" @click="showRemoveModal=false" class="my-0 ">{{ $t('events.modalNo') }}</va-button>
            <va-button type="submit" @click="removeLocation(locationIdInPrompt, indexInPrompt)" class="my-0">{{ $t('events.modalYes') }}</va-button>
          </div>
        </va-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
import KebabMenu from '@/components/menus/KebabMenu.vue'
export default {
  components: { SwappingSquaresSpinner, KebabMenu },
  name: 'Locations',
  mixins: [errorHandlerMixin],
  data () {
    return {
      locations: [],
      locationInfoMessage: null,
      tabValue: 0,
      tabTitles: [this.$t('events.active'), this.$t('events.archived')],
      removeDisabled: false,
      showArchiveModal: false,
      showRemoveModal: false,
      showDuplicateModal: false,
      indexInPrompt: null,
      locationIdInPrompt: null,
    }
  },
  methods: {
    async toLocation (locationId) {
      await this.$router.push({
        name: 'location',
        params: { locationId: locationId },
      })
    },
    showPromptModal (locationId, index, action) {
      this.locationIdInPrompt = locationId
      this.indexInPrompt = index
      if (action === 'archive') {
        this.showArchiveModal = true
      } else if (action === 'remove') {
        this.showRemoveModal = true
      } else if (action === 'duplicate') {
        this.showDuplicateModal = true
      }
    },
    removeLocation (locationId, index) {
      this.removeDisabled = true
      this.$store.dispatch('deleteLocation', locationId)
        .then((resp) => {
          this.locations.splice(index, 1)
          this.removeDisabled = false
          this.showRemoveModal = false
        }).catch((err) => {
          this.errorHandler(err.response)
          this.removeDisabled = false
          this.showRemoveModal = false
        })
    },
    archiveLocation (locationId, index) {
      this.removeDisabled = true
      this.$store.dispatch('toggleLocationArchive', locationId)
        .then((resp) => {
          this.locations.splice(index, 1)
          this.removeDisabled = false
          this.showArchiveModal = false
        }).catch((err) => {
          this.errorHandler(err.response)
          this.removeDisabled = false
          this.showArchiveModal = false
        })
    },
    duplicateLocation (locationId, index) {
      this.removeDisabled = true
      this.$store.dispatch('duplicateLocation', locationId)
        .then((resp) => {
          this.locationInfoMessage = this.$t('events.locationInfoMessage')
          this.removeDisabled = false
          this.showDuplicateModal = false
        }).catch((err) => {
          this.errorHandler(err.response)
          this.locationInfoMessage = null
          this.removeDisabled = false
          this.showDuplicateModal = false
        })
    },
    async initlocations () {
      this.locations.splice(0, this.locations.length, ...this.$store.getters.locations)
      this.$store.commit('setLoading', false)
    },
    tabInput (event) {
      this.locationInfoMessage = null
      this.tabValue = event
      this.$store.commit('setLoading', true)
      this.$store.dispatch('getLocations', this.getLocationsType())
        .then(() => this.initlocations())
        .catch((err) => this.errorHandler(err.response))
    },
    getLocationsType () {
      return this.tabValue === 0 ? 'active' : 'archive'
    },
    getImagePath (image, index) {
      if (image) {
        return image
      }
      return require('@/assets/images/parking-lot-' + (index % 7) + '.jpg')
    },
  },
  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('getLocations', this.getLocationsType())
      .then(() => this.initlocations())
      .catch((err) => this.errorHandler(err.response))
  },
}
</script>

<style lang="scss">
  .location-cards {
    .va-card {
      &__header {
        display: flex;
        align-items: center;

        &-title {
          font-size: 1rem;

          &:hover {
            cursor: pointer;
          }
        }

        &-actions {
          display: flex;
        }
      }

      &__body {
        overflow: visible;

        .va-button--small.va-button--with-right-icon {
          padding-right: 0.75rem;
        }

        p {
          font-size: 14px;
        }
      }
    }
  }

  .va-item-section .va-icon {
    font-size: 1.25rem;
  }

  .locCounts {
    padding-left: 5px;
    font-size: 24px;
    font-weight: bold;
  }

  .markup-tables {
    .va-table {
      width: 100%;
    }

    .va-card {
      max-width: 1200px;
    }
  }
</style>
